export default __webpack_public_path__ + "static/media/knight_of_swords.8091b235.png";